<div class="exception-body notfound">

    <div class="exception-wrapper">
        <div class="exception-content">
            <img src="assets/layout/images/pages/asset-404.svg" alt="freya-layout" />
            <span>404</span>
            <span class="exception-subtitle">Looks like you are lost.</span>
            <button pButton pRipple type="button" label="Go back to home" [routerLink]="['/']"></button>
        </div>

    </div>
</div>